import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './components/utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-background text-slate-300 font-sans selection:bg-accent selection:text-background overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <AudienceSection data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <FAQSection data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}